import { type CanvasHTMLElement } from '@canvas/input-types/base-event-types';

export const setupIgnoredEvents = (root: CanvasHTMLElement): (() => void) => {
  const preventDefault = (evt: Event) => {
    const target = evt.target;
    const closest =
      target != null && 'closest' in target && typeof target.closest === 'function'
        ? target.closest.bind(target)
        : null;

    if (closest?.('[data-allow-native-drag="true"]')) {
      return;
    }

    evt.preventDefault();
  };

  root.addEventListener('dragstart', preventDefault);

  return () => {
    root.removeEventListener('dragstart', preventDefault);
  };
};
